import { Injectable } from '@angular/core';
import {CustomField} from '../include/structures';
import {WSService} from '../include/service'
import { Observable, Observer } from 'rxjs';
import { Globals } from '../globals';
import { e } from 'mathjs';

@Injectable({
  providedIn: 'root'
})
export class CustomfieldsService extends WSService<CustomField> {

  static customfields:any=[];

  constructor() {super("customfields") }

  getCustomFields(table:string,excludeSeparator:boolean=false,checkAccess=false):Observable<CustomField[]>{
    
    let customfields:any=[];
    let cfound=false;
    for(let t of CustomfieldsService.customfields ){
      if(t.table==table){
        customfields=t.customfields;
        cfound=true;
      }
    }

    if(!cfound || excludeSeparator){
      Globals.ws.requestUrl<CustomField[]>("customfields","getItems",[
        (table!=""?"c.table='"+table+"' AND ":"")  +
        "c.status=1"+
        (excludeSeparator==true?" AND c.type!='separator'":"") +
        (checkAccess==true?" AND c.access LIKE '%"+Globals.user.role+"%'":"")
        ,
        "ordering"],true,0,1000).subscribe((items:any)=>{
        if(!excludeSeparator){
          let found=false;
          for(let i=0;i<CustomfieldsService.customfields.length;i++ ){
            if(CustomfieldsService.customfields[i].table==table){
              CustomfieldsService.customfields[i].customfields=items;
              found=true;
            }
          }

          if(!found){
            let t:any={};
            t.table=table;
            t.customfields=items;
            CustomfieldsService.customfields.push(t);

          }
        }
        
        
      });
      
      return Globals.ws.requestUrl<CustomField[]>("customfields","getItems",[(table!=""?"c.table='"+table+"' AND ":"")  +"c.status=1"+(excludeSeparator==true?" AND c.type!='separator'":""),"ordering"],true,0,1000);

    }else{
      
      function sequenceSubscriber(observer: Observer<any[]>) {

        for(let i=0;i<CustomfieldsService.customfields.length;i++ ){
          if(CustomfieldsService.customfields[i].table==table){
            observer.next(CustomfieldsService.customfields[i].customfields);
          }
        }
       
        observer.complete();
        return {unsubscribe() {}};
      }
      
        return new Observable(sequenceSubscriber);
    }

   // return  Globals.ws.requestUrl<CustomField[]>("customfields","getItems",[(table!=""?"c.table='"+table+"' AND ":"")  +"c.status=1"+(excludeSeparator==true?" AND c.type!='separator'":""),"ordering"],true,0,1000);
    
  }

  delete(ids: string[]): Observable<CustomField> {
    CustomfieldsService.customfields=[];
    return super.delete(ids);
}

save(item: CustomField, return_id: Function, checkdeadlinesandactions?: boolean, showAfterMessage?: boolean): void {
  CustomfieldsService.customfields=[];  
    return super.save(item,return_id,checkdeadlinesandactions,showAfterMessage);
}

saveMultiple(items: CustomField[], oncomplete: any, showAfterMessage?: boolean): void {
    CustomfieldsService.customfields=[];  
    return super.saveMultiple(items,oncomplete,showAfterMessage);
}

  importCSV(raw_csv:string,parsing:string,delimiter_csv:string,oncomplete:Function){
    var item2db:any={"raw":raw_csv};
  if(Globals.ws.api_version=="v2")
      item2db={"parsing":parsing,"delimiter_csv":delimiter_csv,"raw":raw_csv};
    Globals.ws.send<any>("customfields","importCSV",item2db,[],oncomplete);
    
  }

  resetAllValueCustomField(id_customfield:number):Observable<any>{
    return  Globals.ws.requestUrl<any>("customfields","resetAllValueCustomField",[id_customfield]);
    
  }

  
}

